import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from './globals'
import { CookieService } from "ngx-cookie-service";
import { TranslateService } from '@ngx-translate/core';
import { environment } from './../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';
  public langActual: string;
  public changeLangLabel;

  cambio: boolean = false;
  activehome: boolean = true;
  activemanage: boolean = false;
  activereport: boolean = false;
  activefinish: boolean = false;

  imginicio = "assets/img/b-inicio.png";
  imgmasiva = "assets/img/masiva.png";
  imgreportes = "assets/img/reportes.png"
  imgregistrar = "assets/img/aplicativo-Registrar.png"

  constructor(private router: Router, private globals: Globals, private cookies: CookieService, private translate: TranslateService) {
    var path = this.cookies.get("pathFuncionario");
    this.globals.path = path;
    this.translate.setDefaultLang('es');
    this.translate.use('es');
    this.langActual = "es";
    this.changeLangLabel = "en";
    if (this.globals.path == "portal-back") {
      this.cookies.set("lenguajeFuncionario", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");      
    }
    else {
      this.cookies.set("lenguajeTurista", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
    }
    

    var lenguajeFuncionario = this.cookies.get("lenguajeFuncionario");
    if (lenguajeFuncionario == "") {
      this.translate.setDefaultLang('es');
      this.translate.use('es');
      this.langActual = "es";
      this.changeLangLabel = "en";
      this.cookies.set("lenguajeFuncionario", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
    }
    else {
      if (lenguajeFuncionario == "es") {
        this.translate.use('es');
        this.langActual = "es";
        this.changeLangLabel = "en";
        this.cookies.set("lenguajeFuncionario", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
      } else {
        this.translate.use('en');
        this.langActual = "en";
        this.changeLangLabel = "es";
        this.cookies.set("lenguajeFuncionario", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
      }
    }


    var lenguajeTurista = this.cookies.get("lenguajeTurista");
    if (lenguajeTurista == "") {
      this.translate.setDefaultLang('es');
      this.translate.use('es');
      this.langActual = "es";
      this.changeLangLabel = "en";
      this.cookies.set("lenguajeTurista", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
    }
    else {
      if (lenguajeTurista == "es") {
        this.translate.use('es');
        this.langActual = "es";
        this.changeLangLabel = "en";
        this.cookies.set("lenguajeTurista", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
      } else {
        this.translate.use('en');
        this.langActual = "en";
        this.changeLangLabel = "es";
        this.cookies.set("lenguajeTurista", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
      }
    }
  }

  irInicio() {
    //this.router.navigate(["/portal-back?c=" + this.globals.userinfo]);
    //window.location = "/portal-back?c=" + this.globals.userinfo;
  }

  goManageImport() {
    this.activehome = false;
    this.activemanage = true;
    this.activereport = false;
    this.activefinish = false;
    this.imginicio = "assets/img/inicio.png";
    this.imgmasiva = "assets/img/b-masiva.png";
    this.imgreportes = "assets/img/reportes.png"
    this.imgregistrar = "assets/img/aplicativo-Registrar.png"
    this.router.navigate(["/manage-import"]);
    this.cambio = false;
  }

  goReport() {
    this.activehome = false;
    this.activemanage = false;
    this.activereport = true;
    this.activefinish = false;
    this.imginicio = "assets/img/inicio.png";
    this.imgmasiva = "assets/img/masiva.png";
    this.imgreportes = "assets/img/b-reportes.png"
    this.imgregistrar = "assets/img/aplicativo-Registrar.png"
    this.router.navigate(["/generate-report"]);
    this.cambio = false;
  }

  goFinishImport() {
    this.activehome = false;
    this.activemanage = false;
    this.activereport = false;
    this.activefinish = true;
    this.imginicio = "assets/img/inicio.png";
    this.imgmasiva = "assets/img/masiva.png";
    this.imgreportes = "assets/img/reportes.png"
    this.imgregistrar = "assets/img/b-aplicativo-Registrar.png"
    this.router.navigate(["/finish-import"]);
    this.cambio = false;
  }

  myFunction() {
    if (this.cambio == false) {
      this.cambio = true;
    } else {
      this.cambio = false;
    }
  }

  changeLang() {
    if (this.langActual == "es") {
      this.translate.use('en');
      this.langActual = "en";
      this.changeLangLabel = "es";
      if (this.globals.path == "portal-back") {
        this.cookies.set("lenguajeFuncionario", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
      }
      else {
        this.cookies.set("lenguajeTurista", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
      }
      this.globals.lenguaje = false;
    } else {
      this.translate.use('es');
      this.langActual = "es";
      this.changeLangLabel = "en";
      if (this.globals.path == "portal-back") {
        this.cookies.set("lenguajeFuncionario", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
      }
      else {
        this.cookies.set("lenguajeTurista", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
      }
      this.globals.lenguaje = true;
    }
  }
}
